import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { OptionTemplateService } from '@app/features/system-settings/option-template/services/option-template.service';
import { ProposalTemplateService } from '@app/features/system-settings/proposal-template/services/proposal-template.service';
import { AuthService } from "@app/core";
var AddAddonModalComponent = /** @class */ (function () {
    function AddAddonModalComponent(fb, bsModalRef, optionTemplateService, proposalTemplateService, authService) {
        this.fb = fb;
        this.bsModalRef = bsModalRef;
        this.optionTemplateService = optionTemplateService;
        this.proposalTemplateService = proposalTemplateService;
        this.authService = authService;
        this.addonType = 'blank';
        this.editAddon = false;
        this.action = 'save';
        this.select2 = false;
        this.optionsData = [];
        this.editorAddon = false;
        this.subscriptions = {};
        this.templatesLoading = true;
        this.showAddOnTemplate = true;
        this.isViewMode = false;
        this.freemiumAccess = false;
        this.showAddNewTemplate = false;
        this.excludeOptions = [];
        this.showDefect = false;
        this.defectSaveEnable = false;
        this.labelName = '';
        this.editOrAddDefectRecommendation = false;
        this.showAddon = false;
    }
    AddAddonModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.labelName = this.editOrAddDefectRecommendation || this.showDefect ? 'Description' : 'add-on.name';
        this.showAddon = this.showAddon ? true : this.editAddon;
        var proposalEditor = this.authService.permitted(['AdvancedProposalEditor.readaccess']) === true;
        if (!proposalEditor) {
            this.freemiumAccess = true;
        }
        else {
            this.freemiumAccess = false;
        }
        this.proposalTemplateService.templateName$.subscribe(function (template) {
            _this.template = template;
        });
        this.getDefectsList();
        this.onClose = new Subject();
        this.buildForm();
        if (this.editorAddon) {
            this.getAllTemplates();
        }
        if (this.selectedAddon && this.selectedAddon.hasOwnProperty('addOnName')) {
            this.addonForm.controls.optionName.setValue(this.selectedAddon.addOnName);
        }
        if (this.selectedAddon && this.selectedAddon.hasOwnProperty('customerOptionName')) {
            this.addonForm.controls.customerOptionName.setValue(this.selectedAddon.customerOptionName);
        }
        if (this.selectedAddon && this.selectedAddon.hasOwnProperty('defectRecommendationList')) {
            this.addonForm.controls.customerOptionName.setValue(this.selectedAddon.defectRecommendationList);
        }
        if (!this.defectSaveEnable) {
            this.addonForm.get('defectRecommendationList').setValidators(null);
            this.addonForm.get('defectRecommendationList').setErrors(null);
        }
        this.isViewMode = this.isViewMode;
        if (this.freemiumAccess) {
            setTimeout(function () {
                _this.addonType = 'template';
            }, 400);
        }
    };
    AddAddonModalComponent.prototype.getDefectsList = function () {
        var _this = this;
        var details = { 'screenType': 'proposal' };
        this.optionTemplateService.getDefectListCustomer(this.customerId, details).subscribe(function (res) {
            _this.defectListData = res.data;
        });
    };
    AddAddonModalComponent.prototype.initializeSelect2 = function (optionTemplates) {
        var dataToSet = [];
        if (optionTemplates && optionTemplates.length) {
            optionTemplates.forEach(function (item) {
                dataToSet.push({
                    id: parseInt(item.id),
                    text: item.optionName
                });
            });
        }
        this.select2TemplateConfig = {
            width: '100%',
            data: dataToSet
        };
        this.templatesLoading = false;
    };
    AddAddonModalComponent.prototype.getSelectedDefect = function (event) {
        var _this = this;
        this.addonForm.get('defectRecommendationList').setValue(event);
        this.addonForm.get('optionName').setValidators(null);
        this.addonForm.get('optionName').setErrors(null);
        this.defectSaveEnable = true;
        this.defectListData.map(function (item) {
            if (item.id == event) {
                _this.defectId = item.id;
                _this.defectDescription = item.description;
            }
        });
    };
    AddAddonModalComponent.prototype.getAllTemplates = function () {
        var _this = this;
        this.additionalInfo['type'] = 'addon';
        this.subscriptions['optionsList'] = this.optionTemplateService.getAllOptionTemplates(this.additionalInfo).subscribe(function (data) {
            if (data) {
                _this.showAddOnTemplate = true;
                for (var index = 0; index < data['excludeOptions'].length; index++) {
                    if (data['excludeOptions'][index]['addon'] == 1) {
                        _this.excludeOptions.push(data['excludeOptions'][index]['id']);
                    }
                }
            }
        });
    };
    // Form buildForm
    AddAddonModalComponent.prototype.buildForm = function () {
        this.addonForm = this.fb.group({
            'id': [''],
            'optionName': ['', Validators.required],
            'customerOptionName': [''],
            'defectRecommendationList': ['', Validators.required]
        });
    };
    // submit option
    AddAddonModalComponent.prototype.save = function (optionType) {
        var addInfo = this.additionalInformation;
        var opportunityIdVal = '';
        var opportunityProposalIdVal = '';
        var proposalTemplatesIdVal = '';
        var setupOptionIdVal = '';
        var selectedType = '';
        var pageNumber = '';
        var formValue = this.addonForm.value;
        if (this.editorAddon) {
            if (this.selectedTemplate == 'proposal') {
                proposalTemplatesIdVal = this.template.id;
            }
            else if (this.selectedTemplate == 'option') {
                setupOptionIdVal = this.template.id;
            }
            else {
                opportunityIdVal = this.opportunityId;
                opportunityProposalIdVal = this.opportunityProposalId;
            }
            selectedType = this.selectedTemplate;
            pageNumber = this.lastPg;
            this.action = 'saving';
            if (optionType == 'blank') {
                var option = {
                    "opportunityId": opportunityIdVal,
                    'opportunityProposalId': opportunityProposalIdVal,
                    "selectedTemplate": selectedType,
                    "proposalTemplateId": proposalTemplatesIdVal,
                    "setupOptionId": setupOptionIdVal,
                    "setupOption": {
                        "optionName": formValue.optionName,
                        "customerOptionName": formValue.customerOptionName,
                    },
                    "addOn": 'true',
                    "lastPageNumber": pageNumber
                };
                this.saveAddon(option);
            }
            else {
                var option = {
                    "opportunityId": opportunityIdVal,
                    'opportunityProposalId': opportunityProposalIdVal,
                    "selectedTemplate": selectedType,
                    "proposalTemplateId": proposalTemplatesIdVal,
                    "setupOptionId": setupOptionIdVal,
                    "optionTemplateId": formValue.optionName,
                    "customerOptionName": formValue.customerOptionName,
                    "addOn": 'true',
                    "lastPageNumber": pageNumber
                };
                this.saveAddon(option);
            }
        }
        else {
            if (!this.editAddon) {
                var defectOption = void 0;
                if (this.defectSaveEnable) {
                    defectOption = {
                        "pageId": this.pageId,
                        "defectDescription": this.defectDescription,
                        "defectId": this.defectId,
                        "screenType": 'proposal'
                    };
                }
                if (addInfo) {
                    opportunityIdVal = addInfo.hasOwnProperty('opportunityId') && addInfo.opportunityId > 0 ? addInfo.opportunityId : '';
                    opportunityProposalIdVal = addInfo.hasOwnProperty('opportunityProposalId') && addInfo.opportunityProposalId > 0 ? addInfo.opportunityProposalId : '';
                    proposalTemplatesIdVal = addInfo.hasOwnProperty('proposalTemplatesId') && addInfo.proposalTemplatesId > 0 ? addInfo.proposalTemplatesId : '';
                    setupOptionIdVal = addInfo.setupOptionId;
                    selectedType = addInfo.selectedTemplate;
                    pageNumber = addInfo.pageNumber;
                }
                this.action = 'saving';
                var option = void 0;
                if (optionType == 'blank') {
                    option = {
                        "opportunityId": opportunityIdVal,
                        'opportunityProposalId': opportunityProposalIdVal,
                        "selectedTemplate": selectedType,
                        "proposalTemplateId": proposalTemplatesIdVal,
                        "setupOptionId": setupOptionIdVal,
                        "setupOption": {
                            "optionName": this.defectSaveEnable ? '' : formValue.optionName,
                            "customerOptionName": this.defectSaveEnable ? '' : formValue.customerOptionName,
                        },
                        defectOption: defectOption,
                        "addOn": 'true',
                        "lastPageNumber": pageNumber
                    };
                    this.saveProposalOption(option);
                }
                else {
                    option = {
                        "opportunityId": opportunityIdVal,
                        'opportunityProposalId': opportunityProposalIdVal,
                        "selectedTemplate": selectedType,
                        "proposalTemplateId": proposalTemplatesIdVal,
                        "setupOptionId": setupOptionIdVal,
                        "optionTemplateId": formValue.optionName,
                        "customerOptionName": formValue.customerOptionName,
                        "addOn": 'true',
                        "lastPageNumber": pageNumber
                    };
                    this.saveProposalOption(option);
                }
            }
            else {
                var addOnName = this.addonForm.controls.optionName.value;
                var customerOptionName = this.addonForm.controls.customerOptionName.value;
                var addOnDetails = {
                    addOnName: addOnName,
                    addOnId: this.selectedAddon.addOnId,
                    customerOptionName: customerOptionName
                };
                this.updateAddOn(addOnDetails);
            }
        }
    };
    AddAddonModalComponent.prototype.updateAddOn = function (addOnDetails) {
        var _this = this;
        this.optionTemplateService.editAddOns(addOnDetails).subscribe(function (data) {
            _this.action = 'save';
            if (!_this.freemiumAccess) {
                var msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
            _this.onClose.next(true);
            _this.bsModalRef.hide();
        }, function (error) {
            console.log('err', error);
        });
    };
    //save Proposal Options
    AddAddonModalComponent.prototype.saveAddon = function (option) {
        var _this = this;
        this.optionTemplateService.addProposalOptions(option).subscribe(function (data) {
            var contentPageId = '';
            if (data) {
                if (data.hasOwnProperty('contentPageId')) {
                    contentPageId = data['contentPageId'];
                }
            }
            if (!_this.freemiumAccess) {
                var msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
            _this.action = 'saving';
            _this.onClose.next({ added: true, type: _this.addonType, contentPageId: contentPageId });
            _this.bsModalRef.hide();
        }, function (error) {
            console.log('err', error);
        });
    };
    //save Proposal Options
    AddAddonModalComponent.prototype.saveProposalOption = function (option) {
        var _this = this;
        this.optionTemplateService.addOrLinkAddOns(option).subscribe(function (data) {
            _this.proposalTemplateService.setSectionData(data);
            _this.action = 'saving';
            if (!_this.freemiumAccess) {
                var msg = {
                    type: 'upgradeFreemium'
                };
                top.postMessage(msg, '*');
            }
            _this.onClose.next({ added: true, type: _this.addonType });
            _this.bsModalRef.hide();
        }, function (error) {
            console.log('err', error);
        });
    };
    // Select option
    AddAddonModalComponent.prototype.optionSelected = function (event) {
        this.addonForm.reset();
        this.addonType = event.target.value;
        if (this.select2 == false) {
            setTimeout(function () {
                $('select.addon-select2').select2();
            }, 500);
            this.select2 = true;
        }
    };
    AddAddonModalComponent.prototype.templateSelected = function (event) {
        this.addonForm.controls['optionName'].setValue(event.templateId);
    };
    AddAddonModalComponent.prototype.ngOnDestroy = function () {
        for (var subscription in this.subscriptions) {
            this.subscriptions[subscription].unsubscribe();
        }
    };
    return AddAddonModalComponent;
}());
export { AddAddonModalComponent };
